"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ramda = require("ramda");

var _animations = require("@qc-modules/animations");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _container = _interopRequireDefault(require("../container"));

var _tab = _interopRequireDefault(require("./tab"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ScrollWrapper = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "tabs__ScrollWrapper",
  componentId: "sc-1ygvjp9-0"
})(["overflow-y:hidden;overflow-x:auto;-webkit-overflow-scrolling:touch;&::-webkit-scrollbar{display:none;}scrollbar-width:none;-ms-overflow-style:none;bottom:-24px;position:relative;"]);
var Wrapper = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "tabs__Wrapper",
  componentId: "sc-1ygvjp9-1"
})(["bottom:0;left:0;overflow:hidden;&:after{content:\"\";display:block;width:48px;height:100%;}"]);
var TabsContainer = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "tabs__TabsContainer",
  componentId: "sc-1ygvjp9-2"
})(["box-sizing:content-box;"]);
var propTypes = {
  /** An array of items to render as tabs */
  activeTab: _propTypes.string,

  /** Array holding an object for each tab's content */
  items: (0, _propTypes.arrayOf)(_propTypes.object),

  /** Callback to be called when active tab animation has ended */
  onTabChangeEnd: _propTypes.func,

  /** Callback to be called when active tab animation has started */
  onTabChangeStart: _propTypes.func,

  /** Callback to be called when tab is clicked */
  onTabClick: _propTypes.func,

  /** Determines positioning of tab wrapper */
  position: _propTypes.string
};

var Tabs = function Tabs(_ref) {
  var activeTab = _ref.activeTab,
      items = _ref.items,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? "relative" : _ref$position,
      _onTabClick = _ref.onTabClick,
      onTabChangeEnd = _ref.onTabChangeEnd,
      onTabChangeStart = _ref.onTabChangeStart;

  var _useState = (0, _react.useState)({
    animating: false,
    currentIndex: 0
  }),
      _useState$ = _useState[0],
      animating = _useState$.animating,
      currentIndex = _useState$.currentIndex,
      setState = _useState[1];

  var updateAnimation = function updateAnimation(status) {
    return setState({
      animating: status,
      currentIndex: currentIndex
    });
  };

  var scrollValue = (0, _react.useMemo)(function () {
    var index = (0, _ramda.findIndex)((0, _ramda.propEq)("path", activeTab), items);

    if (index !== currentIndex) {
      setState({
        animating: true,
        currentIndex: index
      });
    }

    return index / (items.length - 1);
  }, [activeTab, items, currentIndex]);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    alignItems: "flex-start",
    position: position,
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_animations.ScrollTo, {
    allowScrollX: true,
    allowScrollY: false,
    animating: animating,
    scrollByPercentage: true,
    scrollX: scrollValue,
    tag: ScrollWrapper,
    updateAnimation: updateAnimation
  }, /*#__PURE__*/_react["default"].createElement(TabsContainer, {
    "data-test-id": "modules-tabs",
    items: (0, _ramda.isEmpty)(items) ? 0 : items.length,
    px: 0,
    py: 3,
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_container["default"], {
    justifyContent: "flex-start",
    width: ["auto", 1]
  }, (0, _ramda.map)(function (_ref2) {
    var id = _ref2.id,
        path = _ref2.path,
        text = _ref2.text;
    return /*#__PURE__*/_react["default"].createElement(_tab["default"], {
      key: id,
      isActive: path === activeTab,
      onTabChangeEnd: onTabChangeEnd,
      onTabChangeStart: onTabChangeStart,
      onTabClick: function onTabClick(event) {
        return _onTabClick({
          event: event,
          id: id,
          path: path,
          text: text
        });
      },
      path: path,
      text: text
    });
  }, items)))));
};

Tabs.propTypes = propTypes;
Tabs.displayName = "Modules.Tabs";
var _default = Tabs;
exports["default"] = _default;